import { Fee } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface StoreVehicleFeeRequest {
  vehicle_id: number;
  name: string;
  amount: number;
  payment_date: string | null;
  due_date: string;
  is_recurring?: boolean;
  recurrence_last_due_date?: string | null;
  notification_30_days?: number;
  notification_15_days?: number;
}

interface SetPaymentDateRequest {
  payment_date: string;
}

export const vehicleFeeService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<Fee>>("/vehicle_fee", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },

  async store(data: StoreVehicleFeeRequest) {
    const response = await api.post("/vehicle_fee", data);
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<Fee, false>>(
      `/vehicle_fee/${id}`,
    );
    return response.data;
  },

  async update(id: string | number, data: StoreVehicleFeeRequest) {
    const response = await api.put(`/vehicle_fee/${id}`, data);
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/vehicle_fee/${id}`);
    return response.data;
  },

  async setPaymentDate(id: number, data: SetPaymentDateRequest) {
    const response = await api.put(`/vehicle_fee/${id}/pay`, data);
    return response.data;
  },
};
